import { Layout } from "@/components/Layout";
import { CittadiniMeeting } from "@/components/PostFireMeeting";
import { ComingSoonEvent } from "@/components/ComingSoonEvent";

export default function RiunionePage() {
  return (
    <Layout>
      <CittadiniMeeting />
      <ComingSoonEvent />
    </Layout>
  );
}
